import React, { Fragment } from 'react';
import styled from 'styled-components';
import { compose, pure } from 'recompose';
import { withRouter } from 'react-router-dom';

import { Wrapper } from 'components/shared';
import { UserHeader } from 'components/blocks/User';

import { UserTemplate } from 'components/templates';

import { ScrollToTopOnMount } from 'hocs';

import { ApplicationHeader, Title } from '../shared';
import New from './New';

const propTypes = {};

function ExpensesPage() {
  return (
    <UserTemplate header={<UserHeader />}>
      <ApplicationHeader />
      <StyledWrapper>
        <Fragment>
          <Title>Credit and Background Release</Title>
          <New />
        </Fragment>
      </StyledWrapper>
    </UserTemplate>
  );
}

const StyledWrapper = styled(Wrapper)`
  width: 100%;
  max-width: 75rem;
`;

ExpensesPage.propTypes = propTypes;

const enhance = compose(
  ScrollToTopOnMount,
  withRouter,
  pure,
);

export default enhance(ExpensesPage);
